<template>
  <router-view />
</template>

<script>
  export default {
    name: "App",
  };
</script>

<style scoped>
/* Reduce table heading and data font size */
.v-data-table-header th,
.v-data-table td {
  font-size: 12px;
}

/* Reduce font size of input fields */
.v-input input,
.v-input__control {
  font-size: 12px;
}

/* Label font (e.g., "Requisition Date") */
.v-label {
  font-size: 12px;
}

/* For autocomplete/dropdown */
.v-select__selection,
.v-select__selections {
  font-size: 13px;
}
  
</style>
